<template>
    <main class="error-page">
        <h1>404</h1>

        <h2>Página não encontrada</h2>

        <p>
            O endereço indicado não corresponde a nenhuma página da aplicação.
        </p>

        <v-btn
            color="primary"
            :to="{ name: 'dashboard' }"
        >
            Voltar ao início
        </v-btn>
    </main>
</template>

<style scoped>
.error-page {
    display: grid;
    justify-items: center;
    gap: 1rem;
    padding: 4rem 1.5rem;
    text-align: center;
}
</style>